import { PageFilterCard } from 'components/FilterCard';
import { amenitiesMapData } from '../../consts';

import './styles.scss';
import { useTranslation } from 'react-i18next';

export const Filter = ({
  currentFloor,
  onChangeCurrent,
  onHover,
  hoveredAmenity,
  onClick,
}) => {
  const { t } = useTranslation();
  const tabItems = Object.entries(amenitiesMapData).map(([key, value]) => ({
    key,
    value,
  }));

  return (
    <PageFilterCard className="so-do-tien-ich-filter">
      <div className="filter-tab">
        {tabItems.map((item) => (
          <button
            className={`${item.key === currentFloor.id ? 'active' : ''}`}
            onClick={() => onChangeCurrent(item.key)}
            key={item.key}
          >
            {t(item.value.tab)}
          </button>
        ))}
      </div>
      <div className="amenities-list">
        {currentFloor.amenities.map((amenity) => (
          <div
            className="item"
            key={amenity.id}
            onClick={() => onClick(amenity.id)}
            onMouseEnter={() => onHover(amenity.id)}
            onMouseLeave={() => onHover(null)}
          >
            <span className="bullet">{amenity.id}</span>
            <span className="title">{t(amenity.name)}</span>
          </div>
        ))}
      </div>
    </PageFilterCard>
  );
};
